export const TYPE_LOGIN_WITH_EMAIL = 'auth.login.withEmail';
export const TYPE_LOGOUT = 'auth.logout';
export const TYPE_ME = 'auth.me';
